@if (loading) {
<bracelit-preloader [absoluteCentered]="true"
  style="height: 100%; display: flex; justify-content: center; align-items: center;"></bracelit-preloader>
} @else {
<div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: flex-start; justify-content: flex-start;">
  <div style="color: #0F223E !important;
          letter-spacing: -0.34px !important; display: flex; flex-direction: column; width: 100%;">
    <div style="display: flex !important; align-items: center !important; justify-content: right !important;
      height:fit-content !important; width:100% !important;" (click)="onClose()">
      <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer;">
    </div>
    <div class="bold-20px-center-marine primary-border-100"
      style="width: 100%; display: flex; align-items: center; justify-content: center; margin: 25px 0px; font-weight: bold !important; text-align: center !important;">
      {{ (currentLang === 'es') ? 'TUS BONOS' : 'YOUR VOUCHERS' }}
    </div>

    @if (vouchers && vouchers.length > 0) {
    <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
      <div class="bracelit-card"
        style="width: 95%; display: flex; align-items: center; justify-content: center; margin-bottom: 35px !important; box-shadow: none !important">
        <div
          style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center;">
          @for (voucher of vouchers; track voucher.id; let i = $index) {
          <div class="light-16px-center-primary vouchers-form-row linea-debajo"
            style="padding-bottom: 10px; color: #0f223e !important; fill: #0f223e !important; width: 100%; display: flex; align-items: center; justify-content: center; display: flex; flex-direction: column; flex-wrap: wrap;">

            <div class="voucher-data primary-border-100"
              style="width: calc(100%); display: flex; align-items: center; justify-content: center; display: flex !important; place-content: flex-start !important; width: 100% !important">
              <div class="bold-14px-left-primary block-with-text-container"
                style="width: 100%; display: flex; align-items: center; justify-content: flex-start;">
                <p
                  style="font-size: 18px; color: #0f223e !important; fill: #0f223e !important; margin: 10px 0 5px 0 !important">
                  {{voucher.name}}</p>
              </div>
              @if (checkCanceledVoucher(voucher) === true) {
              <div class="vouId" (click)="cancelVoucher(voucher.id, i)"
                style="background-color: #9D0D14; color: white; cursor: pointer; font-size: 16px; font-weight: bold; margin-bottom: 8px;
                              padding: 5px 10px;  text-align: center; display: flex; justify-content: center; align-items: center; display: flex; margin-right: 8px;">
                x
              </div>
              }
            </div>

            @if (voucher.info) {
            @for (data of getVoucherInfoEntries(voucher.info); track data.key) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: space-between; width: 100% !important;">
              {{data.key}}: {{data.value}}
            </div>
            }
            }

            @if (voucher.moneyExtra === null || voucher.moneyExtra === 0 || voucher.moneyExtra === undefined) {
            <div style="display:flex !important; display: flex; justify-content: space-between !important; width:100%">
              <div class="voucher-uses-row"
                style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: flex-start; margin: 0 -12px -12px 0;">
                @for (item of buildArray(voucher.usesLeft); track $index) {
                <div class="secondary-background-full"
                  style="border-radius: 50%; width: 3px !important; height: 3px !important; padding: 0 12px 12px 0 !important; margin: 0px 12px 12px 0px !important;">
                </div>
                }
                @if ((voucher.usesLeft % 1) !== 0) {
                <div class="secondary-background-semi"
                  style="border-radius: 50%; width: 3px !important; height: 3px !important; padding: 0 12px 12px 0 !important; margin: 0px 12px 12px 0px !important;">
                </div>
                }
                @if (voucher.uses > voucher.usesLeft) {
                <ng-container>
                  @for (item of buildArray(voucher.uses - voucher.usesLeft); track $index) {
                  <div class="secondary-background-empty"
                    style="border-radius: 50%; width: 3px !important; height: 3px !important; padding: 0 12px 12px 0 !important; margin: 0px 12px 12px 0px !important;">
                  </div>
                  }
                </ng-container>
                }
              </div>
              <div class="bold-14px-left-primary"
                style="display: flex; align-items: center; margin-left: 10px; font-weight: bold !important; font-size: 14px !important; color: #0f223e !important; fill: #0f223e !important;">
                @if (voucher.usesLeft <= voucher.uses) { <ng-container>
                  {{voucher.usesLeft}}/{{voucher.uses}}
                  </ng-container>
                  }
                  @if (voucher.usesLeft > voucher.uses) {
                  <ng-container>
                    {{voucher.usesLeft}}/{{voucher.uses*voucher.usesLeft}}
                  </ng-container>
                  }
              </div>
            </div>

            <!-- Details/Summary para mostrar información adicional -->
            <details #detailsElement style="width: 100%; margin-top: 10px;">
              <summary (click)="onDetailsToggle(detailsElement, voucher)"
                style="font-size: 12px; cursor: pointer; display: flex; align-items: center; color: #0f223e; font-weight: 500; padding: 8px 0;">
                <mat-icon svgIcon="info" class="primary-color"
                  style="width: 17px; height: 17px; margin-right: 6px;"></mat-icon>
                {{ (currentLang === 'es') ? 'Ver detalles' : 'View details' }}
              </summary>

              @if (getVoucherDetails(voucher.id)?.loading) {
              <div style="padding: 20px; text-align: center;">
                <bracelit-preloader [diameter]="30" [absoluteCentered]="true"></bracelit-preloader>
              </div>
              } @else {
              @if (getVoucherDetails(voucher.id)?.voucherBlueprint) {
              @let details = getVoucherDetails(voucher.id);
              @let bp = details.voucherBlueprint;

              <div style="padding: 15px; background-color: #f5f5f5; border-radius: 4px; margin-top: 10px;">
                <!-- Información de fichas (solo si no es ticketing) -->
                @if (voucher) {
                <div style="margin-bottom: 15px;">
                  <div style="display: flex; align-items: center; margin-bottom: 8px;">
                    <div class="secondary-background-full"
                      style="border-radius: 50%; width: 8px; height: 8px; margin-right: 8px;"></div>
                    <span class="light-14px-left-marine">{{leftLabel}} {{voucher.usesLeft|number: '1.2-2'}}
                      {{tokensLabel2}}</span>
                  </div>
                  <div style="background-color:#C0C4CA; width: 100%; height:1px; margin: 8px 0;"></div>
                  <div style="display: flex; align-items: center; margin-top: 8px;">
                    <div class="secondary-background-empty"
                      style="border-radius: 50%; width: 8px; height: 8px; margin-right: 8px;"></div>
                    <span class="light-14px-left-marine">{{leftLabel2}} {{details.gastado|number: '1.2-2'}}
                      {{tokensLabel2}}</span>
                  </div>

                  @if (bp.moneyExtra > 0) {
                  <div style="margin-top: 15px; text-align: center;">
                    <div class="light-14px-center-marine">{{messageMoneyExtra}}</div>
                    <div class="bold-16px-center-marine">{{bp.moneyExtra | number: '1.0-2'}} €</div>
                  </div>
                  }

                  @if (bp.uses > 0) {
                  <div style="margin-top: 15px; text-align: center;" class="bold-14px-center-marine">
                    @if (voucher.usesLeft <= bp.uses) { Total {{tokenLabel2}}s: {{bp.uses}} } @else { Total
                      {{tokenLabel2}}s: {{voucher.usesLeft * bp.uses}} } </div>
                      }
                  </div>
                  }

                  <!-- Descripción -->
                  @if (bp.description) {
                  <div style="margin-top: 15px;" class="light-14px-left-marine" [innerHTML]="bp.description"></div>
                  }

                  <!-- Intervalo de compra -->
                  @if (bp.preSaleOfferStart && bp.preSaleOffer) {
                  <div style="margin-top: 15px;">
                    <div class="light-14px-center-marine" style="font-weight: bold; margin-bottom: 5px;">{{buyInterval}}
                    </div>
                    <div class="light-14px-center-marine">{{start}}: {{bp.preSaleOfferStart}}</div>
                    <div class="light-14px-center-marine">{{end}}: {{bp.preSaleOffer}}</div>
                  </div>
                  }

                  <!-- Intervalo de uso -->
                  @if (bp.startingDate && bp.endingDate && bp.startingDate !== '2000-01-01 00:00:00' && bp.endingDate
                  !== '3000-01-01 00:00:00') {
                  <div style="margin-top: 15px;">
                    <div class="light-14px-center-marine" style="font-weight: bold; margin-bottom: 5px;">{{useInterval}}
                    </div>
                    <div class="light-14px-center-marine">{{start}}: {{bp.startingDate}}</div>
                    <div class="light-14px-center-marine">{{end}}: {{bp.endingDate}}</div>
                  </div>
                  }

                  <!-- Máximo a vender -->
                  @if (bp.maximumToSell) {
                  <div class="light-14px-center-marine" style="font-weight: bold; margin-top: 15px;">
                    {{maximumToSellText}}: {{bp.maximumToSell}}
                  </div>
                  }

                  <!-- Máximo de veces para recargar -->
                  @if (bp.maximumTimesToRecharge) {
                  <div class="light-14px-center-marine" style="font-weight: bold; margin-top: 15px;">
                    {{maximumTimesToRechargeText}}: {{bp.maximumTimesToRecharge}}
                  </div>
                  }
                </div>
                }
                }
            </details>
            }
          </div>
          }
        </div>
      </div>
    </div>
    } @else {
    <div style="text-align: center; padding: 20px; color: #0F223E;">
      {{ (currentLang === 'es') ? 'No tienes bonos comprados' : 'You have no purchased vouchers' }}
    </div>
    }
  </div>
</div>
}